import { apiClient, type UnbundleResultEntity } from '@/libs/api'

export type UnbundleShipmentOrdersRequest = {
  tenantKey: string
  shipmentOrderIds: number[]
}

export const unbundleShipmentOrders = async ({
  tenantKey,
  shipmentOrderIds
}: UnbundleShipmentOrdersRequest): Promise<UnbundleResultEntity> => {
  const response = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.bundles.unbundle.$post({
      body: { shipmentOrderIds }
    })
  return response.data
}
